// extracted by mini-css-extract-plugin
export default {"container":"MenuIcon_container__0gagC","bar":"MenuIcon_bar__JeC+6","active":"MenuIcon_active__h2A5Y"};